module.exports = __webpack_public_path__ + "img/Face.2ef90c2f.png";